import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setBenchmarkYear } from "../../store/benchmarkYearSlice";
import { ChevronDown, Check, Loader2 } from "lucide-react";
import { getAvailableYear } from "../../services/complianceService";

const BenchmarkYearPicker = ({ disabled }) => {
  const dispatch = useDispatch();
  const selectedYear = useSelector((state) => state.benchmarkYear.year);
  const [showDropdown, setShowDropdown] = useState(false);
  const [years, setYears] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchYears = async () => {
      setLoading(true);
      try {
        const res = await getAvailableYear();
        if (res.status === "success") {
          setYears(res.data);
        } else {
          console.error("Failed to load available years");
        }
      } catch (error) {
        console.error("Error fetching available years:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchYears();
  }, []);

  const handleYearSelect = (year) => {
    dispatch(setBenchmarkYear(year));
    setShowDropdown(false);
  };

  return (
    <div className="relative inline-block">
      {/* Button */}
      <button
        onClick={() => !disabled && setShowDropdown(!showDropdown)}
        disabled={disabled}
        className={`flex items-center gap-2 px-4 py-2 text-sm font-medium border rounded-lg shadow-sm transition-colors
          ${disabled
            ? "bg-gray-100 text-gray-400 border-gray-200 cursor-not-allowed"
            : "bg-white text-gray-800 border-gray-200 hover:bg-gray-50"
          }`}
      >
        <span>
          {loading ? "Loading..." : `Year: ${selectedYear || "Select"}`}
        </span>
        <ChevronDown
          className={`w-4 h-4 text-gray-500 transition-transform ${showDropdown ? "rotate-180" : ""}`}
        />
      </button>

      {/* Dropdown */}
      {showDropdown && (
        <div className="absolute mt-2 z-30 bg-white border border-gray-200 rounded-xl shadow-lg w-44">
          {loading ? (
            <div className="flex justify-center items-center py-4 text-gray-500">
              <Loader2 className="animate-spin w-4 h-4 mr-2" /> Loading...
            </div>
          ) : years.length > 0 ? (
            years.map((year) => (
              <button
                key={year}
                onClick={() => handleYearSelect(year)}
                className={`flex justify-between items-center w-full text-sm px-4 py-2 hover:bg-blue-50 text-gray-700
                  ${selectedYear === year ? "bg-blue-100 font-medium" : ""}`}
              >
                <span>{year}</span>
                {selectedYear === year && <Check className="w-4 h-4 text-blue-600" />}
              </button>
            ))
          ) : (
            <div className="text-sm text-gray-500 px-4 py-2">No years found</div>
          )}
        </div>
      )}
    </div>
  );
};

export default BenchmarkYearPicker;
